import { ColumnsType } from '@agro-club/agroclub-shared'
import { isBidProductParamsEnabled } from 'env'
import { EXPANDABLE_COLUMN_WIDTH } from 'modules/constants'
import { convertSortingToAntDFormat } from 'modules/domain/common/tableUtils'
import { getMainParameter } from 'modules/utils/helpers'
import formatNumber from 'modules/utils/numbers/formatNumber'
import { labelQuantity } from 'modules/utils/numbers/formatQuantity'
import { labelTarif } from 'modules/utils/numbers/formatTarif'
import { useTranslation } from 'react-i18next'
import * as renderers from 'views/components/Table/renderers'
import PriceCell from './PriceCell'
import SwitchCell from './SwitchCell'
import ActualiseCell from './ActualiseCell'

const useColumns = ({ refetch, nested, sortParam }): ColumnsType => {
  const { t } = useTranslation('user')

  return [
    nested
      ? {
          width: EXPANDABLE_COLUMN_WIDTH,
          render: () => ' ',
        }
      : null,
    {
      title: t('list.tableHeadersBidPrice.created'),
      width: 100,
      dataIndex: 'created',
      render: renderers.date,
    },
    {
      title: t('list.tableHeadersBidPrice.modified'),
      width: 100,
      dataIndex: 'modified',
      render: renderers.date,
    },
    nested
      ? {
          width: isBidProductParamsEnabled ? 200 : 100,
          render: () => ' ',
        }
      : {
          title: t('list.tableHeadersBidPrice.product'),
          width: isBidProductParamsEnabled ? 200 : 100,
          dataIndex: 'product',
          render: (product) => product?.title,
        },
    {
      title: t('bid:form.mainParameter'),
      width: 300,
      dataIndex: 'main_parameter',
      sorter: true,
      sortOrder: convertSortingToAntDFormat('main_parameter', sortParam),
      render: (_, row) => getMainParameter(row?.parameters),
    },
    {
      title: t('common:address'),
      autoWidth: 508,
      dataIndex: 'address',
      render: (value) => (nested ? ' ' : value?.address),
    },
    {
      title: labelQuantity(),
      width: 120,
      dataIndex: 'quantity',
      align: 'right',
      render: (value) => formatNumber(value),
    },
    {
      title: labelTarif(t('common:price.default')),
      width: 120,
      dataIndex: 'price',
      render: (_, bid) => <PriceCell refetch={refetch} currentValue={bid.price} bid={bid} />,
    },
    {
      title: t('list.tableHeadersBidPrice.actualise'),
      width: 90,
      dataIndex: 'is_archiving_candidate',
      render: (_, bid) => <ActualiseCell refetch={refetch} bid={bid} />,
    },
    {
      title: t('list.tableHeadersBidPrice.publish'),
      align: 'left',
      width: 120,
      render: (_, bid) => {
        return <SwitchCell bid={bid} refetch={refetch} />
      },
    },
  ].filter(Boolean) as ColumnsType
}

export default useColumns
